(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcTestResultFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$mdToast', 'grcControlService', 'attachmentService'];

    function Controller($rootScope, $scope, $state, $mdToast, grcControlService, attachmentService) {
        
        $scope.testResult = $scope.boxModel;
        $scope.controlTest = $scope.boxContext.ControlTest;

        $scope.ctrlCtxt = {};

        // Page is dirty
        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Get Lookups and hide ratings if necessary
        grcControlService
              .getAllLookups()
              .then(function (controlLookups) {
                  $scope.controlLookups = controlLookups;
                  $scope.ratingsOfEffectiveness = controlLookups.RatingsOfEffectiveness;

                  if ($scope.readOnly) return;

                  _.forEach($scope.effectivenessRatingLevels, function (ratingLevel) {
                      if (!$scope.showRatingLevel(ratingLevel)) {
                          $scope.testResult[ratingLevel.model] = null;
                      }
                  });
              });

        // Rating Levels
        $scope.effectivenessRatingLevels = [{
            model: 'DesignEffectivenessID',
            parentModel: null,
            controlLevel: 'Design-Effectiveness',
            hideOnControlLevels: [],
            disableOnParentEffectivenessIDs: [],
            errorOnNullModels: ['DesignEffectivenessID'],
            errorMsg: 'You must test for Design Effectiveness.'
        }, {
            model: 'ImplementationEffectivenessID',
            parentModel: 'DesignEffectivenessID',
            controlLevel: 'Implementation-Effectiveness',
            hideOnControlLevels: ['Design-Effectiveness'],
            disableOnParentEffectivenessIDs: [57, 58], // Unsatisfactory, Not Tested
            errorOnNullModels: ['DesignEffectivenessID', 'ImplementationEffectivenessID'],
            errorMsg: 'You must test for Design and Implementation Effectiveness.'
        }, {
            model: 'OperationalEffectivenessID',
            parentModel: 'ImplementationEffectivenessID',
            controlLevel: 'Operational-Effectiveness',
            hideOnControlLevels: ['Design-Effectiveness', 'Implementation-Effectiveness'],
            disableOnParentEffectivenessIDs: [57, 58], // Unsatisfactory, Not Tested
            errorOnNullModels: ['DesignEffectivenessID', 'ImplementationEffectivenessID', 'OperationalEffectivenessID'],
            errorMsg: 'You must test for Design, Implementation and Operational Effectiveness.'
        }];

        // Show Rating Level
        $scope.showRatingLevel = function (rating) {
            if ($scope.readOnly && $scope.testResult[rating.model]) return true;

            if (_.indexOf(rating.hideOnControlLevels, $scope.controlTest.LevelOfTesting.Value) > -1) return false;

            return true;
        };

        // Is Rating Level Disabled
        $scope.isRatingLevelDisabled = function (rating) {
            if ($scope.readOnly) return true;

            if (!rating.parentModel ||
                !$scope.testResult[rating.parentModel] ||
                !$scope.showRatingLevel(rating)) {
                return false;
            }

            var parentRating = _.find($scope.effectivenessRatingLevels, { model: rating.parentModel });

            if (_.indexOf(rating.disableOnParentEffectivenessIDs, $scope.testResult[parentRating.model]) > -1) return true;

            return false;
        };

        // On Rating Level Update
        $scope.onRatingLevelUpdate = function () {
            if ($scope.readOnly) return;

            _.forEach($scope.effectivenessRatingLevels, function (ratingLevel) {
                if ($scope.isRatingLevelDisabled(ratingLevel)) {
                    $scope.testResult[ratingLevel.model] = 58; // Not Tested
                }
            });

            $scope.pageIsDirty();
        };

        // Show Discard Changes Action?
        $scope.showDiscardChangesAction = function () {
            return $scope.ctrlCtxt.needSaveChanges;
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $scope.loadingStatus.isLoading = true;
            $state.reload();
        };

        // Show Submit Action?
        $scope.showSubmitAction = function () {
            if ($scope.readOnly) return false;

            return $scope.ctrlCtxt.needSaveChanges;
        };

        // Submit
        $scope.submit = function () {
            $scope.loadingStatus.isLoading = true;
            return grcControlService
                .createOrUpdateTestResult($scope.controlTest.ControlID, $scope.testResult)
                .then(function (updatedTestResult) {
                    _.assign($scope.testResult, updatedTestResult);

                    return grcControlService
                       .submitTestResult($scope.controlTest.ControlID, $scope.testResult)
                       .then(function (updatedTestResult) {
                           _.assign($scope.testResult, updatedTestResult);

                           $mdToast.show(
                               $mdToast
                                   .simple()
                                   .content('Test result has been submitted')
                                   .position('top right')
                                   .hideDelay($scope.govNotificationDelay)
                                   .action('OK')
                                   .theme('primary')
                           );

                           // Need refresh
                           $rootScope.$broadcast('need-refresh');

                           $scope.pageIsNotDirty();
                       });
                })
                .finally(function() {
                    $scope.loadingStatus.isLoading = false;
                });
           
        };

        // Download attachment
        $scope.getDownloadAttachmentUrl = function (attachmentId) {
            if (_.isUndefined($scope.testResult.ControlTest)) return;

            return grcControlService.getDownloadAttachmentUrl(
                $scope.testResult.ControlTest.ControlID,
                $scope.testResult.ControlTest.ControlTestID,
                attachmentId);
        };

        // Upload attachments
        $scope.uploadAttachments = function (files, events) {
            if (_.isUndefined($scope.testResult.Attachments)) {
                $scope.testResult.Attachments = [];
            }

            attachmentService.uploadSelectedFiles(files, events, $scope.testResult.Attachments)
                             .then(function () {
                                 $scope.pageIsDirty();
                             });
        };

        // Delete attachment
        $scope.deleteAttachment = function (attachment) {
            attachmentService
                .delete(attachment.AttachmentExternalID)
                .then(function () {
                    var attachments = $scope.testResult.Attachments;
                    _.remove(attachments, function (att) {
                        return att.AttachmentExternalID === attachment.AttachmentExternalID;
                    });
                });
        };
    }
})();